import { KYMW0900Model } from "../kymw0900.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * アイコンコード取得サービス
 *
 * @export GetIconDataService
 * @class GetIconDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetIconDataService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetIconDataService
   */
  private successFunc: Function;

  model: KYMW0900Model;

  vo = {
    markCode: '',
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetIconDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MarkCode: this.vo.markCode,
        OrderCode: this.model.orderCode,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetIconDataService
   */
  execute(model: any, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getIconData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetIconDataService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc?.(data);
    }
  }
}
